import React from "react";
import { Dialog } from "@material-ui/core/";
import { useTranslation } from "react-i18next";
import "../CustomizeView/styles.css";
import close from "../../../assets/icons/close.svg";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import cloneDeep from "lodash/cloneDeep";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";

function Filters({ setOpen, customColumn, setCustomColumn }) {
  const { t } = useTranslation();
  const copyCustomColumn = cloneDeep(customColumn);

  const handleClose = () => {
    setOpen(false);
  };
  function handleChange(columnOptions) {
    if (columnOptions?.display === false) {
      columnOptions.display = true;
    } else {
      columnOptions.display = false;
    }
  }

  function handleSave() {
    setCustomColumn(copyCustomColumn);
    setOpen(false);
  }
  return (
    <div>
      <Dialog
        id="autom-addNew-modal"
        data-test="autom-add-new"
        open={true}
        onClose={handleClose}
      >
        <div className="customize-view">
          <div className="customize-view-head">
            <div className="customize-view-title">
              <b>{t("CONTENT.DATATABLE.TOOLBAR.FILTERS")}</b>
            </div>
            <div className="customize-view-button-close" onClick={handleClose}>
              <img
                src={close}
                alt="customize-view-icon"
              />
            </div>
          </div>
          <div style={{ textAlign: "left", marginTop: 20 }}>
            <div className="filters-header">
              {" "}
              {t("CONTENT.DATATABLE.TOOLBAR.COLUMNS")}
            </div>
            {copyCustomColumn &&
              copyCustomColumn.map(
                (column, index) =>
                  index !== 0 &&
                  (column?.options?.display === undefined ||
                    column?.options?.display === true) &&
                  column?.name !== "actions" &&
                  column?.name !== "status" && (
                    <div key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            defaultChecked={
                              column?.options.display
                                ? column?.options.display === false
                                  ? false
                                  : true
                                : column?.options.display === undefined
                                  ? true
                                  : false
                            }
                            onChange={() => handleChange(column.options)}
                            color="primary"
                          />
                        }
                        label={
                          <div className="filters-checkbox">
                            {column.label?.length <= 1 ? t('CONTENT.LIBRARIES.STATUS') : column.label}
                          </div>
                        }
                      />
                    </div>
                  )
              )}
            {copyCustomColumn &&
              copyCustomColumn.map(
                (column, index) =>
                  index !== 0 &&
                  column?.options?.display === false && column?.name !== "actions" && (
                    <div key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                            checkedIcon={<CheckBoxIcon fontSize="small" />}
                            defaultChecked={
                              column?.options.display
                                ? column?.options.display === false
                                  ? false
                                  : true
                                : column?.options.display === undefined
                                  ? true
                                  : false
                            }
                            onChange={() => handleChange(column.options)}
                            color="primary"
                          />
                        }
                        label={
                          <div className="filters-checkbox">
                            {column.label?.length <= 1 ? t('CONTENT.LIBRARIES.STATUS') : column.label}
                          </div>
                        }
                      />
                    </div>
                  )
              )}
            <div className="customize-view-button-group" onClick={handleSave}>
              <div className="customize-view-button-group-1">
                <div className="customize-view-apply-changes">
                  {t("CONTENT.DATATABLE.TOOLBAR.APPLY-CHANGES")}
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default Filters;
